import { http } from '@/utils'

// 查询机构
export const getOrgTreeDataApi = (data: any): any =>
  http.post(`/hrm/organizations/child`, data).then((res) => {
    return {
      ...res,
      data: res?.data?.id ? [res?.data] : []
    }
  })

// 查询机构
export const organizeSearchMap: Record<string, any> = {
  Query: getOrgTreeDataApi,
  Auth: (data: any): any => http.post(`/hrm/organizations/search`, data, { loading: false }),
  NoAuth: (data: any): any => http.post(`/hrm/organizations/search/all`, data, { loading: false })
}

// 查询成本中心
export const getCostCenterTreeDataApi = (data: any): any => http.post(`/hrm/cost/centers`, data)

// 查询成本中心
export const costCenterSearchMap = {
  Query: getCostCenterTreeDataApi,
  Auth: getCostCenterTreeDataApi,
  NoAuth: getCostCenterTreeDataApi
}

//
export const TREE_SELECT_API_MAP: Record<string, any> = {
  Organize: organizeSearchMap,
  CostCenter: costCenterSearchMap
}
